<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id + 'Label'" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal',
    props: {
      id: {
        type: String,
        default () {
          return 'modal'
        }
      }
    },
    data () {
      return {
      }
    },
    methods: {
      show () {
        $(this.$el).modal('show')
      },
      hide () {
        $(this.$el).modal('hide')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~@/assets/css/components/modal';
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue